import React from 'react'
import { startNewCitiesQuiz } from '../../store/quiz/quiz.actions'
import { useAction } from '../utils/react-redux'
import { useSelector } from 'react-redux'
import { selectQuizHasStarted } from '../../store/quiz/quiz.selectors'
import RectangleActionButton, { COLOR_BLUE, SIZE_MEDIUM } from '../genericComponents/buttons/RectangleActionButton'
import s from './QuizMainContent.less'
import { QUIZ_CITIES_LEVELS, QUIZ_TYPES } from './quiz.constants'
import { TAG_CLICK_QUIZ_PLAY } from '../analytics/analytics.tagids.constants'
import analyticsConstants from '../analytics/analytics.constants'

const QuizCitiesStartGame = () => {
  const execStartNewQuiz = useAction(startNewCitiesQuiz)
  const quizHasStarted = useSelector(selectQuizHasStarted)

  if (quizHasStarted) return <></>

  const getClickHandler = (level) => () => execStartNewQuiz({ level })

  return (
    <div className={s.levelContainer}>
      <div>Lancer une partie</div>
      <div className={s.buttons}>
        {[2, 4, 8, 12].map((level) => (
          <RectangleActionButton
            key={`level-${level}`}
            label={QUIZ_CITIES_LEVELS[level]}
            color={COLOR_BLUE}
            size={SIZE_MEDIUM}
            onClick={getClickHandler(level)}
            tagData={{
              type: TAG_CLICK_QUIZ_PLAY,
              tagInfo: {
                type: analyticsConstants.quiz.types[QUIZ_TYPES.CITIES],
                level: QUIZ_CITIES_LEVELS[level],
              },
            }}
          />
        ))}
      </div>
    </div>
  )
}

export default QuizCitiesStartGame
